import React, { useState, useCallback } from 'react';
import moment from 'moment';
import { Button, Checkbox, Modal, TextField } from '@scale/scaleui';
import { cancelSession } from '../api';
import { useCreateWebinarSession } from '../hooks/useCreateWebinarSessionStore';
import { findAllFutureSessions } from '../helpers';

interface CancelationModalProps {
  toggleModal: () => void;
  collection: any[];
}

export const CancelationModal: React.FC<CancelationModalProps> = ({ toggleModal, collection }) => {
  const { reloadSessions } = useCreateWebinarSession();
  const futureSessions = findAllFutureSessions(collection);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [reason, setReason] = useState<string>('');
  const [selectedSessions, setSelectedSessions] = useState<string[]>([]);
  const handleCancelSession = useCallback(() => {
    (async () => {
      setIsLoading(true);
      await Promise.all(selectedSessions.map(async s => await cancelSession(s, reason)));
      setIsLoading(false);
      reloadSessions();
      toggleModal();
    })();
  }, [selectedSessions, reloadSessions, toggleModal, reason]);

  const handleSelectSession = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const sessionId = e.target.id;
      if (selectedSessions.includes(sessionId))
        setSelectedSessions(selectedSessions.filter(s => s !== sessionId));
      else setSelectedSessions([...selectedSessions, sessionId]);
    },
    [selectedSessions],
  );
  return (
    <Modal
      title="Select Session(s) to Cancel"
      open={true}
      onClose={toggleModal}
      actions={
        <div className="flex items-center gap-2 justify-end">
          <Button
            disabled={
              isLoading || !selectedSessions.length || !reason.length || !futureSessions.length
            }
            onClick={handleCancelSession}
          >
            {isLoading ? 'Canceling...' : 'Cancel Session'}
          </Button>
        </div>
      }
    >
      <div className="scaleui scale-tailwind flex flex-col gap-2 mb-2 max-h-[320px] overflow-y-auto p-1">
        {futureSessions.map(s => (
          <Checkbox
            key={s._id}
            id={s._id}
            checked={selectedSessions.includes(s._id)}
            onChange={handleSelectSession}
            label={`${moment(s.eventStart).format('dddd MMM D, YYYY [at] h[:]mmA ')}`}
          />
        ))}
      </div>
      <TextField
        label="Cancelation Reason"
        placeholder="Enter reason..."
        value={reason}
        onChange={e => setReason(e.target.value)}
      />
    </Modal>
  );
};
